import { LoadingButton } from '@mui/lab';
import React, { useContext, useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';
import { SeasonShowContext } from '../../Providers/SeasonShowProvider';
import { SnackbarContext } from '../../Providers/SnackbarProvider';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { graphql } from 'gql';

const UpdateSeason = graphql(`
    mutation UpdateSeasons_EditSeasonDialog($where: SeasonWhere, $update: SeasonUpdateInput) {
        updateSeasons(where: $where, update: $update) {
            seasons {
                id
                title
            }
        }
    }`);

type Props = {
    open: boolean;
    onClose: () => void;
}

export default function EditSeasonDialog({ open, onClose }: Props) {
    const { selectedSeason, setSelectedSeason } = useContext(SeasonShowContext);
    const { success, error } = useContext(SnackbarContext);

    const [title, setTitle] = useState<string | undefined>(selectedSeason?.title);

    useEffect(() => {
        if (open) {
            setTitle(selectedSeason?.title);
        }
    }, [open, selectedSeason])

    const [updateSeason, { loading }] = useMutation(UpdateSeason);

    const handleSave = async () => {
        try {
            await updateSeason({
                variables: { where: { id: selectedSeason!.id }, update: { title }},
            });

            setSelectedSeason({ ...selectedSeason!, title: title! });

            onClose();
            success('Show edited');
        } catch (e) {
            // @ts-ignore
            error('Failed to edit show. ' + e.message);
        }
    }

    const handleClose = () => {
        setTitle(selectedSeason?.title);
        onClose();
    }

    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter') {
            handleSave();
        }
    }

    if (!selectedSeason) {
        return null;
    }

    return (
        <Dialog open={open}>
            <DialogTitle>Edit Season</DialogTitle>
            <DialogContent>
                <TextField
                    sx={{ mt: 1, mb: 1 }}
                    label="Title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    onKeyDown={handleKeyDown}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} variant='text'>Cancel</Button>
                <LoadingButton
                    onClick={handleSave}
                    disabled={!title}
                    variant='contained'
                    loading={loading}
                >
                    Save
                </LoadingButton>
            </DialogActions>
        </Dialog>
    )
}